import axios, { AxiosInstance } from 'axios';

import { getConfig } from './config';

let api: AxiosInstance;

export default function makeApi() {
  if (!api) {
    api = axios.create({
      baseURL: getConfig('API_URL'),
    });
  }

  return api;
}
